// src/oura/docs/writeFlag.ts
//
// Whether the Docs WRITE controls show here (phase 2: create, questions,
// share, review email, answers, resolve, file the approved PDF). A separate
// switch from Phase 1's read switch, so Phase 1 can go live first (2.19).
//
// Fails closed. On: the write switch VITE_ENABLE_OURA_DOCS_WRITE_LIVE is
// exactly "true" AND the read switch VITE_ENABLE_OURA_DOCS_LIVE is too (writes
// against sample reads would answer for docs that do not exist); or the write
// sample store on a local fixtures run (the dev server, with the docs read
// switch, the write switch and VITE_ENABLE_OURA_LIVE_API all unset), which
// mirrors DOCS_SAMPLE_SERVES. A build is never a fixtures run, so a build
// missing its switches shows no Phase 2 or Phase 3 control.
// No imports, so the router, the rail and the services can all read it.

/** The write routes are live: both switches set. */
export const DOCS_WRITE_LIVE =
    import.meta.env.VITE_ENABLE_OURA_DOCS_WRITE_LIVE === "true" && import.meta.env.VITE_ENABLE_OURA_DOCS_LIVE === "true";

/** The write sample store answers: the dev server, Oura and the docs on fixtures. */
export const DOCS_WRITE_SAMPLE_SERVES =
    import.meta.env.DEV &&
    import.meta.env.VITE_ENABLE_OURA_DOCS_WRITE_LIVE !== "true" &&
    import.meta.env.VITE_ENABLE_OURA_DOCS_LIVE !== "true" &&
    import.meta.env.VITE_ENABLE_OURA_LIVE_API !== "true";

/** Every Phase 2 and Phase 3 write control reads this. */
export const DOCS_WRITE_ON = DOCS_WRITE_LIVE || DOCS_WRITE_SAMPLE_SERVES;
